// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const deleteProjectTemplatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Project template ID"),
});

export const deleteProjectTemplateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project template deleted successfully
 */
export const deleteProjectTemplate200Schema = z.object({});

export const deleteProjectTemplateMutationResponseSchema = z.lazy(() => deleteProjectTemplate200Schema);
